<template>
  <div class="tutor-list">
    <div class="list-table__title">Extra</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="extras"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #[`cell(tutor.id)`]="extra">
        <router-link :to="{name: 'TutorDetail',params: { id: extra.item.tutor.id }}" >
          {{ extra.item.tutor.id}}
        </router-link>
      </template>
      <template #[`cell(tutor.name)`]="extra">
        <router-link :to="{name: 'TutorDetail',params: { id: extra.item.tutor.id }}" >
          {{ extra.item.tutor.name}}
        </router-link>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Extra } from '@/store/extras/types';
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Moment } from 'moment'

@Component
export default class ExtraTable extends Vue {
  @Prop({}) extras!: Extra[]

  private fields: Array<Object> = [
    {
      key: 'tutor.id',
      label: 'Tutor ID',
    },
    {
      key: 'tutor.name',
      label: 'Tutor Name',
    },
    {
      key: 'yearMonth',
      label: 'Year/Month',
      formatter: (extra: Moment): string => extra.format('YYYY/MM'),
    },
    {
      key: 'position',
      label: 'Position',
    },
    {
      key: 'extraLesson',
      label: 'Extra',
    },
  ]
}
</script>

<style>
.tutor-list .list-table .list-table__head {
  font-size: .6rem;
}

.tutor-list .list-table .list-table__body td {
  font-size: .6rem;
  height: 70px;
}
.tutor-list .list-table .list-table__body td[aria-colindex="6"] {
  overflow-wrap:break-word;
}
</style>
